module.exports = __webpack_public_path__ + "static/6M_2024_Financial_Reporting_HSE_Finance_Sarl-ccd9bd0d511ddd4843393ad005d8c3d1.pdf";